export enum JurisdictionStatus {
  APPROVED = 'approved',
  SUBMITTED = 'submitted',
  PENDING = 'pending',
  PAST = 'pastOneYear',
  EXPIRED = 'expired'
}
